<template>
    <div id="triggerSettings">
        <div class="scroll-list">
            <div class="trigger-settings">
                <div class="row">
                    <div class="col-6">
                        <md-field>
                            <label>Activate</label>
                            <md-select v-model="currentTrigger.activate">
                                <md-option value="Enter">Enter</md-option>
                                <md-option value="Exit">Exit</md-option>
                                <md-option value="Proximity">Proximity</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="col-6">
                        <md-field>
                            <label>Radius Distance (m)</label>
                            <md-input v-model="currentTrigger.radiusDistance"></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.radiusDistance.$invalid">Radius must be number greater than 0</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <md-field class="md-has-value">
                            <label>Heading</label>
                            <md-input v-if="headingEnabled" v-model="currentTrigger.heading"></md-input>
                            <md-input v-else disabled placeholder="Omnidirectional" value=""></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.heading.$invalid">Heading must be between [0 and 360]</span>
                    </div>
                    <div class="col-6">
                        <md-field>
                            <label>Tolerance (deg)</label>
                            <md-input v-model="currentTrigger.tolerance"></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.tolerance.$invalid">Tolerance must be between [30 and 360]</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <md-field>
                            <label>Mode</label>
                            <md-select v-model="currentTrigger.triggerMode">
                                <md-option value="Interrupt">Interrupt</md-option>
                                <md-option value="Ignore">Ignore</md-option>
                                <md-option value="Queue">Queue</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="col-6">
                        <md-field class="md-has-value">
                            <label>Delay (s)</label>
                            <md-input v-model="currentTrigger.delay"></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.delay.$invalid">Delay must be a valid numeric value</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <md-field>
                            <label>Latitude</label>
                            <md-input v-model="currentTrigger.latLng.lat"></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.latLng.lat.$invalid">Latitude must be a valid numeric value [-90 to 90]</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <md-field>
                            <label>Longitude</label>
                            <md-input v-model="currentTrigger.latLng.lng"></md-input>
                        </md-field>
                        <span class="trigger-form-error" v-if="$v.currentTrigger.latLng.lng.$invalid">Longitude must be a valid numeric value [-180 to 180]</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <md-field>
                            <label>Status</label>
                            <md-select v-model="currentTrigger.on_off">
                                <md-option value="1">On</md-option>
                                <md-option value="0">Off</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
            </div>
        </div>

        <footer v-if="triggerEdited && !$v.currentTrigger.$invalid" class="aside-btn">
            <div class="btn-wrap">
                <md-button class="md-raised md-primary" @click="saveTriggerZone(currentTrigger); returnToPrevious(); toggleShowTriggerTabs();">Save Trigger Zone</md-button>
            </div>
        </footer>

    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {between, required, numeric} from 'vuelidate/lib/validators';
import {validLatOrLng, notWhitespace} from '../../includes/validations.js';

export default {
  computed: {
    ...mapGetters('routes', ['currentRoute']),
    ...mapGetters('triggers', ['initialTrigger', 'currentTrigger', 'triggerEdited', 'headingEnabled'])
  },
  methods: {
    ...mapActions('triggers', ['saveTriggerZone', 'loadRouteTriggers', 'clearStateTriggersList', 'toggleTriggerHovered']),
    ...mapActions('editor', ['toggleShowTriggerTabs']),
    returnToPrevious () {
      this.$router.push('/tour/topic');
    }
  },
  validations: {
    currentTrigger: {
      heading: {
        between: between(0, 360),
        required,
        notWhitespace
      },
      tolerance: {
        between: between(30, 360),
        required,
        notWhitespace
      },
      radiusDistance: {
        between: between(0, 45000),
        required,
        notWhitespace
      },
      delay: {
        numeric,
        required
      },
      latLng: {
        lng: {
          required,
          notWhitespace,
          validLatOrLng,
          between: between(-180, 180)
        },
        lat: {
          required,
          notWhitespace,
          validLatOrLng,
          between: between(-90, 90)
        }
      }
    }
  }
};
</script>
<style lang="scss">
#triggerSettings .scroll-list {
    position: absolute;
    top: 240px;
    bottom: 50px;
    left: 0;
    right: 0;
    overflow: auto;
}

#triggerSettings .trigger-form-error {
    font-size: 12px;
    color: red;
    top: -20px;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TriggerSettingsTab.vue